import "./style.css"

import { useTranslation } from "react-i18next"
import { FaChevronRight } from "react-icons/fa6"
import { Link, useLocation, useParams } from "react-router-dom"

import { useEnrolledByIdData } from "@/queries/queries"

const breadcrumbArrow = <FaChevronRight size={12} />

export default function Breadcrumb() {
  const { t } = useTranslation()
  const { roundId, lectureId } = useParams()
  const location = useLocation()

  const pathSegments = location.pathname.split("/").filter(Boolean)

  const { data } = useEnrolledByIdData()

  const round = data?.data
  const lectureName = round?.lectures?.find(
    (l) => l.id === Number(lectureId)
  )?.name

  return (
    <div className="d-flex align-items-center gap-3 breadcrumb">
      {/* Enrolled Courses */}
      <div className="d-flex align-items-center gap-3">
        <Link to="/enrolled">{t("breadCrumbs.enrolledCourses")}</Link>
      </div>

      {/* Round Details */}
      {pathSegments.includes("round") && round && (
        <div className="d-flex align-items-center gap-3">
          <span>{breadcrumbArrow}</span>
          <Link to={`/enrolled/round/${roundId}`}>{round.name}</Link>
        </div>
      )}
      {pathSegments.includes("plan") && round && (
        <div className="d-flex align-items-center gap-3">
          <span>{breadcrumbArrow}</span>
          <span>{t("enrolledCoursesPage.rounds.viewPlan")}</span>
        </div>
      )}
      {pathSegments.includes("lectures") && round && (
        <div className="d-flex align-items-center gap-3">
          <span>{breadcrumbArrow}</span>
          <span>{lectureName}</span>
        </div>
      )}
      {pathSegments.includes("videos") && round && (
        <div className="d-flex align-items-center gap-3">
          <span>{breadcrumbArrow}</span>
          <span>{t("breadCrumbs.videos")}</span>
        </div>
      )}
    </div>
  )
}
